export default {
  gemsFlying: {
    mobile: () => import('./gems-flying.json'),
    tablet: () => import('./gems-flying.desktop.json'),
    desktop: () => import('./gems-flying.desktop.json'),
  },
};
